import accessors from '../accessors';

const canBeDragged = (element) => Boolean(accessors.getDragConstraintForElement(element));

export default canBeDragged;
